import api from './baseAPIService';

// Function to register a new user
export const registerUser = async (userData) => {
  try {
    const response = await api.post('/auth/register', userData);
    return response.data;
  } catch (error) {
    if (error.response?.data?.detail) {
      throw new Error(error.response.data.detail);
    }
    throw new Error('Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.');
  }
};


// Function to delete a user
export const deleteUser = async () => {
  try {
    const response = await api.delete('/auth/delete-user');
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to delete user' };
  }
};

// Function to login with credentials
export const loginWithCredentials = async (credentials) => {
  try {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  } catch (error) {
    if (error.response?.data?.detail) {
      // Handle structured error messages
      if (typeof error.response.data.detail === 'object') {
        throw {
          code: error.response.data.detail.code,
          message: error.response.data.detail.message
        };
      }
      // Handle string error messages
      throw {
        code: 'AUTH_ERROR',
        message: error.response.data.detail
      };
    }
    throw {
      code: 'UNKNOWN_ERROR',
      message: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.'
    };
  }
};

// Function to change password
export const changePassword = async (passwordData) => {
  try {
    const response = await api.post('/auth/password-change', passwordData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to change password' };
  }
};

// Function to validate the token
export const validateToken = async () => {
  try {
    const response = await api.get('/auth/validate-token');
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to validate token' };
  }
};

// Function to get user email
export const getUserEmail = async () => {
  try {
    const response = await api.get('/auth/user-email');
    return response.data.email;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to get user email' };
  }
};

// Function to verify email
export const verifyEmail = async (token) => {
  try {
    const response = await api.post(`/auth/verify-email/${token}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to verify email' };
  }
};

// Function to request password reset
export const requestPasswordReset = async (email) => {
  try {
    const response = await api.post('/auth/password-reset-request', { email });
    return response.data;
  } catch (error) {
    if (error.response?.data?.detail) {
      throw new Error(error.response.data.detail);
    }
    throw new Error('Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.');
  }
};

// Function to reset password
export const resetPassword = async (token, newPassword) => {
  try {
    const response = await api.post(`/auth/password-reset/${token}`, {
      password: newPassword
    });
    return response.data;
  } catch (error) {
    if (error.response?.data?.detail) {
      throw new Error(error.response.data.detail);
    }
    throw new Error('Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.');
  }
};

// Function to resend verification email
export const resendVerificationEmail = async (email) => {
  try {
    const response = await api.post('/auth/resend-verification', { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to resend verification email' };
  }
};


export const getNumberOfUsers = async () => {
  try {
    const response = await api.get('/auth/number-of-users');
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to get number of users' };
  }
};

export const getQuestionLimit = async () => {
  try {
    const response = await api.get('/user/check_question_limit');
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to get question limit' };
  }
};